// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__+CEde","subTitleBold":"BoxSubTitle_subTitleBold__UwhTT"};